import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { hasPlaceholderEntraConfig } from './app/core/auth/entra-auth.config';
import { environment } from './environments/environment';

if (hasPlaceholderEntraConfig(environment.entraExternalId)) {
  console.warn('mkzs-portal-ui-angular is using placeholder Microsoft Entra External ID configuration.');
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((error: unknown) => {
  console.error('Failed to bootstrap mkzs-portal-ui-angular', error);
});

